import { render } from "./CreateInstanceFromTokensWidget.vue?vue&type=template&id=4dc6d17d&scoped=true"
import script from "./CreateInstanceFromTokensWidget.vue?vue&type=script&lang=js"
export * from "./CreateInstanceFromTokensWidget.vue?vue&type=script&lang=js"

import "./CreateInstanceFromTokensWidget.vue?vue&type=style&index=0&id=4dc6d17d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc6d17d"]])

export default __exports__